import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, message, Input, Select, Row, Col } from 'antd';
import AppLayout from '../../components/AppLayout';
import { useNavigate } from 'react-router-dom';

const WorkOrderList: React.FC = () => {
  const [orders, setOrders] = useState<any[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<any[]>([]);
  const [filters, setFilters] = useState({ work_order_no: '', status: '', stage: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const demoOrders = Array.from({ length: 50 }, (_, i) => ({
      _id: `${i + 1}`,
      work_order_no: `WOR-${(i + 1).toString().padStart(3, '0')}`,
      quantity: Math.floor(Math.random() * 100) + 1,
      status: ['Pending', 'In Progress', 'Completed'][i % 3],
      stage: ['Cutting', 'Assembly', 'Packaging'][i % 3],
    }));
    setOrders(demoOrders);
    setFilteredOrders(demoOrders);
  }, []);

  const handleFilterChange = (field: string, value: string) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    const filtered = orders.filter(order =>
      (newFilters.work_order_no === '' || order.work_order_no.toLowerCase().includes(newFilters.work_order_no.toLowerCase())) &&
      (newFilters.status === '' || order.status === newFilters.status) &&
      (newFilters.stage === '' || order.stage === newFilters.stage)
    );
    setFilteredOrders(filtered);
  };

  const handleDelete = async (id: string) => {
    message.success(`Demo: Work order ${id} deleted`);
    setFilteredOrders(prev => prev.filter(o => o._id !== id));
  };

  return (
    <AppLayout>
      <h3>Work Orders</h3>
      <Button type="primary" onClick={() => navigate('/manufacturing/work-order/add-work-order')} style={{ marginBottom: 16 }}>
        Add Work Order
      </Button>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8}>
          <Input
            placeholder="Search Work Order No"
            value={filters.work_order_no}
            onChange={(e) => handleFilterChange('work_order_no', e.target.value)}
          />
        </Col>
        <Col span={8}>
          <Select
            placeholder="Filter by Status"
            value={filters.status}
            onChange={(value) => handleFilterChange('status', value)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="Pending">Pending</Select.Option>
            <Select.Option value="In Progress">In Progress</Select.Option>
            <Select.Option value="Completed">Completed</Select.Option>
          </Select>
        </Col>
        <Col span={8}>
          <Select
            placeholder="Filter by Stage"
            value={filters.stage}
            onChange={(value) => handleFilterChange('stage', value)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="Cutting">Cutting</Select.Option>
            <Select.Option value="Assembly">Assembly</Select.Option>
            <Select.Option value="Packaging">Packaging</Select.Option>
          </Select>
        </Col>
      </Row>

      <Table
        dataSource={filteredOrders}
        rowKey="_id"
        columns={[
          { title: 'Work Order No', dataIndex: 'work_order_no' },
          { title: 'Quantity', dataIndex: 'quantity' },
          { title: 'Status', dataIndex: 'status' },
          { title: 'Stage', dataIndex: 'stage' },
          {
            title: 'Actions',
            render: (_: any, record: any) => (
              <>
                <Button
                  style={{ marginRight: 8 }}
                  onClick={() => navigate(`/manufacturing/work-order/${record._id}`)}
                >
                  View
                </Button>
                <Popconfirm
                  title="Are you sure to delete this work order?"
                  onConfirm={() => handleDelete(record._id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger>Delete</Button>
                </Popconfirm>
              </>
            ),
          },
        ]}
        pagination={{ pageSize: 10 }}
      />
    </AppLayout>
  );
};

export default WorkOrderList;
